export const dateTimeFormatWithoutMiliSeconds = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const noTimeZoneDateFormat = 'YYYY-MM-DDTHH:mm:ss.SSS';
export const defaultDateFormatForBeServices = 'YYYY-MM-DD';
export const defaultDateFormat = 'MM/DD/YY';
export const dateFormatLongYear = 'MM/DD/YYYY';
